(() => {
  const handle = window.location.pathname.match(/^\/products\/([^/?#]+)/)?.[1];
  if (!handle) return;

  const isCozyBed = handle === 'cozy-cat-sleeping-bag-bed';
  if (!isCozyBed) return;
  document.documentElement.classList.add('po-cozy-sticky-atc');

  const storefrontUrl = new URL(window.location.href);
  if (window.Shopify?.currency?.active !== 'USD' && storefrontUrl.searchParams.get('country') !== 'US') {
    storefrontUrl.searchParams.set('country', 'US');
    window.location.replace(storefrontUrl.toString());
    return;
  }

  let queued = false;
  let defaultBundleSelected = false;

  const parseMoney = (text) => {
    const numeric = String(text || '').match(/[0-9][0-9.,\s]*/)?.[0]?.trim();
    if (!numeric) return Number.NaN;

    let normalized = numeric.replace(/\s/g, '');
    const lastDot = normalized.lastIndexOf('.');
    const lastComma = normalized.lastIndexOf(',');

    if (lastDot >= 0 && lastComma >= 0) {
      const decimal = lastDot > lastComma ? '.' : ',';
      const grouping = decimal === '.' ? ',' : '.';
      normalized = normalized.split(grouping).join('').replace(decimal, '.');
    } else {
      const separator = lastDot >= 0 ? '.' : lastComma >= 0 ? ',' : '';
      if (separator) {
        const decimals = normalized.length - normalized.lastIndexOf(separator) - 1;
        normalized = decimals === 2
          ? normalized.replace(separator, '.')
          : normalized.split(separator).join('');
      }
    }

    return Number(normalized);
  };

  const formatMoneyLike = (sample, amount, decimals) => {
    const source = String(sample || '');
    const match = source.match(/[0-9][0-9.,\s]*/);
    if (!match || !Number.isFinite(amount)) return source;

    const prefix = source.slice(0, match.index);
    const suffix = source.slice((match.index || 0) + match[0].length);
    const locale = document.documentElement.lang || navigator.language || 'en';
    const formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount);

    return `${prefix}${formatted}${suffix}`;
  };

  const setText = (element, value) => {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  };

  const getBars = () => [...document.querySelectorAll('.kaching-bundles .kaching-bundles__bar')];
  const getBarTitle = (bar) => bar?.querySelector('.kaching-bundles__bar-title')?.textContent.trim() || '';
  const getBarPrice = (bar) => bar?.querySelector('.kaching-bundles__bar-price')?.textContent.trim() || '';
  const getBarComparePrice = (bar) => bar?.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || '';
  const getBarSubtitle = (bar) => bar?.querySelector('.kaching-bundles__bar-subtitle')?.textContent.trim() || '';
  const getQuantity = (bar) => Number(getBarTitle(bar).match(/\d+/)?.[0]);
  const isSelected = (bar) => Boolean(
    bar?.querySelector('input[type="radio"]:checked') || /selected|active/i.test(bar?.className || '')
  );

  const selectBar = (bar) => {
    if (!bar) return;
    const input = bar.querySelector('input[type="radio"]');
    if (input && !input.checked) input.click();
    else if (!isSelected(bar)) bar.click();
  };

  const closeBundleSheet = () => {
    const shell = document.querySelector('.po-bundle-sheet-shell');
    if (!shell) return;
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('po-bundle-sheet-open');
    document.querySelector('.po-sticky-bundle-trigger')?.setAttribute('aria-expanded', 'false');
  };

  const renderSheetOptions = (bars) => {
    const list = document.querySelector('.po-bundle-sheet__options');
    if (!list) return;

    list.innerHTML = '';
    bars.forEach((bar) => {
      const quantity = getQuantity(bar);
      if (!Number.isFinite(quantity)) return;

      const selected = isSelected(bar);
      const option = document.createElement('div');
      option.className = `po-bundle-sheet__option${selected ? ' is-selected' : ''}`;
      option.dataset.quantity = String(quantity);
      option.setAttribute('role', 'radio');
      option.setAttribute('aria-checked', selected ? 'true' : 'false');
      option.innerHTML = `
        ${quantity === 2 ? '<span class="po-bundle-sheet__best-value" aria-label="Best Value">Best<br>Value</span>' : ''}
        <button class="po-bundle-sheet__option-main" type="button">
          <span class="po-bundle-sheet__radio" aria-hidden="true"></span>
          <span class="po-bundle-sheet__copy">
            <span class="po-bundle-sheet__title-line">
              <strong>Buy ${quantity}</strong>
              <span class="po-bundle-sheet__shipping">FREE SHIPPING</span>
            </span>
            <span class="po-bundle-sheet__subtitle">${getBarSubtitle(bar)}</span>
          </span>
          <span class="po-bundle-sheet__pricing">
            <strong>${getBarPrice(bar)}</strong>
            <del>${getBarComparePrice(bar)}</del>
          </span>
        </button>
      `;

      const main = option.querySelector('.po-bundle-sheet__option-main');
      main.setAttribute('aria-label', `${getBarTitle(bar)}, ${getBarPrice(bar)}`);
      main.addEventListener('click', () => {
        selectBar(bar);
        window.setTimeout(() => {
          scheduleUpdate();
          renderSheetOptions(getBars());
        }, 100);
      });

      if (selected) {
        const sourceVariants = [...bar.querySelectorAll('.kaching-bundles__bar-variant')];
        if (sourceVariants.length) {
          const variants = document.createElement('div');
          variants.className = 'po-bundle-sheet__variants';
          const names = quantity > 1 ? 'Choose a color for each item' : 'Color';
          variants.innerHTML = `<span class="po-bundle-sheet__variant-title">${names}</span>`;

          sourceVariants.forEach((sourceVariant, index) => {
            const sourceSelect = sourceVariant.querySelector('select');
            if (!sourceSelect) return;

            const row = document.createElement('label');
            row.className = 'po-bundle-sheet__variant-row';
            const sourceImage = sourceVariant.querySelector('img');
            const itemLabel = quantity > 1 ? `Item ${index + 1}` : 'Color';
            row.innerHTML = `
              ${sourceImage ? `<img src="${sourceImage.src}" alt="">` : ''}
              <span>${itemLabel}</span>
            `;

            const select = document.createElement('select');
            select.setAttribute('aria-label', quantity > 1 ? `Color for item ${index + 1}` : 'Color');
            [...sourceSelect.options].forEach((sourceOption) => {
              const choice = document.createElement('option');
              choice.value = sourceOption.value;
              choice.textContent = sourceOption.textContent.trim();
              choice.selected = sourceOption.selected;
              select.appendChild(choice);
            });
            select.addEventListener('change', () => {
              sourceSelect.value = select.value;
              sourceSelect.dispatchEvent(new Event('input', { bubbles: true }));
              sourceSelect.dispatchEvent(new Event('change', { bubbles: true }));
              window.setTimeout(scheduleUpdate, 80);
            });
            row.appendChild(select);
            variants.appendChild(row);
          });

          option.appendChild(variants);
        }
      }

      list.appendChild(option);
    });
  };

  const ensureBundleSheet = () => {
    let shell = document.querySelector('.po-bundle-sheet-shell');
    if (shell) return shell;

    shell = document.createElement('div');
    shell.className = 'po-bundle-sheet-shell';
    shell.setAttribute('aria-hidden', 'true');
    shell.innerHTML = `
      <button class="po-bundle-sheet__overlay" type="button" aria-label="Close bundle choices"></button>
      <section class="po-bundle-sheet" role="dialog" aria-modal="true" aria-labelledby="po-bundle-sheet-title">
        <span class="po-bundle-sheet__handle" aria-hidden="true"></span>
        <div class="po-bundle-sheet__heading">
          <h2 id="po-bundle-sheet-title">Choose your bundle</h2>
          <button class="po-bundle-sheet__close" type="button" aria-label="Close bundle choices">&times;</button>
        </div>
        <div class="po-bundle-sheet__options" role="radiogroup" aria-label="Bundle quantity"></div>
      </section>
    `;
    document.body.appendChild(shell);
    shell.querySelector('.po-bundle-sheet__overlay').addEventListener('click', closeBundleSheet);
    shell.querySelector('.po-bundle-sheet__close').addEventListener('click', closeBundleSheet);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shell.classList.contains('is-open')) closeBundleSheet();
    });
    return shell;
  };

  const openBundleSheet = () => {
    const bars = getBars();
    if (!bars.length) return;
    const shell = ensureBundleSheet();
    renderSheetOptions(bars);
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('po-bundle-sheet-open');
    document.querySelector('.po-sticky-bundle-trigger')?.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => shell.querySelector('.po-bundle-sheet__close')?.focus(), 220);
  };

  const ensureStickyShell = () => {
    let sticky = document.querySelector('.sticky-atc');
    if (sticky) return sticky;

    sticky = document.createElement('aside');
    sticky.className = 'sticky-atc sticky-atc--after-scroll sticky-atc-mobile-button-only po-live-sticky-atc';
    sticky.innerHTML = `
      <div class="sticky-atc-container">
        <div class="sticky-atc__left"><div class="sticky-atc__image"><img alt=""></div></div>
        <div class="sticky-atc__left-inner">
          <div class="sticky-atc__title"></div>
          <div class="sticky-atc__price"></div>
        </div>
        <div class="sticky-atc__right">
          <button class="sticky-atc__button" type="button"><span class="product-form-button-text">Add to Cart</span></button>
        </div>
      </div>
    `;

    const productImage = document.querySelector('[id^="MediaGallery-"] img, .product__media img');
    const stickyImage = sticky.querySelector('.sticky-atc__image img');
    if (productImage?.src) stickyImage.src = productImage.src;
    stickyImage.alt = productImage?.alt || '';
    setText(sticky.querySelector('.sticky-atc__title'), document.querySelector('h1')?.textContent.trim() || 'Cozy Cat Sleeping Bag Bed');

    sticky.querySelector('.sticky-atc__button').addEventListener('click', () => {
      const primaryButton = document.querySelector('#my-add-to-cart-button, .product-form__submit, form[action*="/cart/add"] button[type="submit"]');
      primaryButton?.click();
    });

    const updateVisibility = () => {
      sticky.classList.toggle('sticky-atc--active', window.scrollY > 360);
    };
    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
    document.body.appendChild(sticky);
    return sticky;
  };

  const ensureStickyControls = (selectedBar) => {
    const sticky = ensureStickyShell();
    const stickyPrice = sticky?.querySelector('.sticky-atc__price');
    const image = sticky?.querySelector('.sticky-atc__image');
    const container = sticky?.querySelector('.sticky-atc-container');
    if (!sticky || !stickyPrice || !image || !container) return;

    let trigger = stickyPrice.querySelector('.po-sticky-bundle-trigger');
    if (!trigger) {
      stickyPrice.innerHTML = `
        <button class="po-sticky-bundle-trigger" type="button" aria-haspopup="dialog" aria-expanded="false">
          <span class="po-sticky-bundle-trigger__quantity"></span>
          <em>Best Value</em>
          <strong class="po-sticky-bundle-trigger__price"></strong>
          <svg aria-hidden="true" viewBox="0 0 12 8"><path d="m1 1 5 5 5-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
        </button>
      `;
      trigger = stickyPrice.querySelector('.po-sticky-bundle-trigger');
      trigger.addEventListener('click', openBundleSheet);
    }

    image.setAttribute('role', 'button');
    image.setAttribute('tabindex', '0');
    image.setAttribute('aria-label', 'Choose a bundle offer');
    if (!image.dataset.poBundleBound) {
      image.dataset.poBundleBound = 'true';
      image.addEventListener('click', openBundleSheet);
      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openBundleSheet();
        }
      });
    }

    if (!container.querySelector('.po-bundle-callout')) {
      const callout = document.createElement('button');
      callout.type = 'button';
      callout.className = 'po-bundle-callout';
      callout.setAttribute('aria-label', 'Open bundle offers');
      callout.innerHTML = `
        <span>Bundle &amp; Save More!</span>
        <svg aria-hidden="true" viewBox="0 0 72 42"><path d="M65 5c-22 0-39 8-42 19-2 8 8 10 12 4 5-8-16-11-28 7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="3"/><path d="m7 35 9-1-5-8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>
      `;
      callout.addEventListener('click', openBundleSheet);
      container.appendChild(callout);
    }

    const title = getBarTitle(selectedBar) || 'Buy 2';
    const price = getBarPrice(selectedBar);
    setText(trigger.querySelector('.po-sticky-bundle-trigger__quantity'), title);
    setText(trigger.querySelector('.po-sticky-bundle-trigger__price'), price);
    trigger.querySelector('em').hidden = getQuantity(selectedBar) !== 2;
    sticky.setAttribute('aria-label', `Sticky purchase bar: ${title}, ${price}`);
  };

  const updateBundle = () => {
    queued = false;

    const bundle = document.querySelector('.kaching-bundles');
    if (!bundle) return;

    const bars = getBars();
    const buyOne = bars.find((bar) => getBarTitle(bar) === 'Buy 1');
    const buyTwo = bars.find((bar) => getQuantity(bar) === 2);
    const buyOnePrice = buyOne?.querySelector('.kaching-bundles__bar-price');
    const buyOneText = buyOnePrice?.textContent.trim() || '';
    const singlePrice = parseMoney(buyOneText);

    if (!buyOne || !Number.isFinite(singlePrice)) return;

    setText(buyOne.querySelector('.kaching-bundles__bar-subtitle'), 'Standard Price');

    bars.forEach((bar) => {
      const quantity = getQuantity(bar);
      if (!Number.isFinite(quantity) || quantity <= 1) return;

      const bundlePrice = bar.querySelector('.kaching-bundles__bar-price');
      const total = parseMoney(bundlePrice?.textContent);
      if (!Number.isFinite(total)) return;

      const perItem = formatMoneyLike(bundlePrice.textContent, total / quantity, 0);
      const regularAmount = singlePrice * quantity;
      const discount = Math.max(0, Math.round((1 - total / regularAmount) * 100));
      const benefit = quantity === 3 ? 'Maximum savings • ' : '';
      setText(bar.querySelector('.kaching-bundles__bar-subtitle'), `${benefit}Save ${discount}% • ${perItem} each`);
      setText(bar.querySelector('.kaching-bundles__bar-full-price'), formatMoneyLike(buyOneText, regularAmount, 2));
    });

    bundle.querySelectorAll('.kaching-bundles__bar-most-popular').forEach((badge) => {
      badge.setAttribute('aria-label', 'Best value');
      badge.setAttribute('title', 'Best value');
    });

    document
      .querySelectorAll('.product__info-container .main-price, [id^="price-container-"] .main-price')
      .forEach((price) => setText(price, buyOneText));

    const buttons = document.querySelector('.product__info-container .product-form__buttons');
    if (buttons && !document.querySelector('.po-bundle-trust')) {
      const trust = document.createElement('p');
      trust.className = 'po-bundle-trust';
      trust.textContent = 'Free shipping • Secure checkout • Easy returns';
      buttons.insertAdjacentElement('afterend', trust);
    }

    if (isCozyBed) {
      if (!defaultBundleSelected && buyTwo) {
        defaultBundleSelected = true;
        if (!isSelected(buyTwo)) {
          selectBar(buyTwo);
          window.setTimeout(scheduleUpdate, 80);
          return;
        }
      }

      const selectedBar = bars.find(isSelected) || buyTwo || buyOne;
      if (window.matchMedia('(max-width: 749px)').matches) {
        ensureStickyControls(selectedBar);
        setText(document.querySelector('.sticky-atc .product-form-button-text'), 'Add to Cart');
      }
    }
  };

  const scheduleUpdate = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(updateBundle);
  };

  scheduleUpdate();
  new MutationObserver(scheduleUpdate).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();

